// extracted by mini-css-extract-plugin
module.exports = {"header":"dialog_header__UthTi","description":"dialog_description__3qr-F","actions":"dialog_actions__1aC1C","action":"dialog_action__k7EKR","footer":"dialog_footer__Lev3z"};